import React, { useState } from "react";
import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";
import DefaultButton from "../../styles/materialButtonStyle";
import MaterialDialog from "../../styles/materialDialog";
import { StyledBlockAction, StyledBlockLabel, StyledFormBlock } from "../../styles/styledTabsForm";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";

const TransactionFailForm = ({ transactionId, notification, setNotification, type, fetchAction }) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setVisible(false);
  };

  const handleFailTransaction = () => {
    setLoading(true);

    axios.patch(`/api/${type}s/fail/${transactionId}`, {}, userAuthenticationConfig()).then(response => {
      if (response && response.status === HTTP_STATUSES.HTTP_NO_CONTENT) {
        setNotification({
          ...notification,
          visible: true,
          type: "success",
          message: "Transaction status has been successfully updated"
        });
        fetchAction();
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => {
      setLoading(false);
      setVisible(false);
    });
  };

  return (
    <>
      <MaterialDialog
        open={visible}
      >
        <StyledDialogWrapper>
          <StyledDialogHead>
            Change status
          </StyledDialogHead>
          <StyledDialogContent>
            Change the status of transaction to Fail?
          </StyledDialogContent>
          <StyledDialogAction col="2">
            <DefaultButton
              onClick={handleClose}
              color="danger"
              disabled={loading}
            >
              Cancel
            </DefaultButton>
            <DefaultButton
              color="success"
              onClick={handleFailTransaction}
              disabled={loading}
            >
              Confirm
            </DefaultButton>
          </StyledDialogAction>
        </StyledDialogWrapper>
      </MaterialDialog>

      <StyledFormBlock>
        <StyledBlockLabel>
          Change status
        </StyledBlockLabel>
        <StyledBlockAction>
          <DefaultButton
            color="danger"
            onClick={() => setVisible(true)}
          >
            Fail transaction
          </DefaultButton>
        </StyledBlockAction>
        <div className="clear-column" />
      </StyledFormBlock>
    </>
  );
};

export default TransactionFailForm;